import { Grid, GridProps } from "@mui/material";

type FormElementProps = {
  title: string;
  containerGridProps?: GridProps;
  titleGridProps?: GridProps;
  contentGridProps?: GridProps;
};
export default function FormElement({
  title,
  children,
  containerGridProps,
  titleGridProps,
  contentGridProps,
}: React.PropsWithChildren<FormElementProps>) {
  return (
    <Grid container spacing={1} {...containerGridProps}>
      <Grid item xs={12} md={2} {...titleGridProps}>
        <span style={{ fontWeight: "bold", fontSize: "18px" }}>{title}</span>
      </Grid>
      <Grid
        sx={{ paddingRight: "15px" }}
        item
        xs={12}
        md={10}
        {...contentGridProps}
      >
        {children}
      </Grid>
    </Grid>
  );
}
